import { _isMobile, _isOnScreen, _on, _once } from '../../utils';

_on('click', 'js--cookie-policy', () => {
  document.querySelector('.policies').classList.add('hidden');
  localStorage.setItem('policy|usage', 'true');
});

const useCookieBanner = () => {
  const cookieBanner = document.querySelector('.policies');
  if (cookieBanner) {
    if (localStorage.getItem('policy|usage')) {
      cookieBanner.classList.add('hidden');
    } else {
      cookieBanner.classList.remove('hidden');
    }
  }
};

if (_isMobile()) {
  _isOnScreen(
    '.header__beacon',
    () => {},
    {},
    () => {
      _once(() => {
        useCookieBanner();
      })();
    },
  );
} else {
  useCookieBanner();
}
